import { debounce } from 'lodash/function';
export const isWindow = () => typeof window !== 'undefined';

export const debouncedNavigation = debounce(
  (url) => {
    window.location.hash =  url;
  },
  100,
  { leading: true, trailing: false },
);
